import React, { useContext } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useRouteMatch } from "react-router";
import { useHistory } from "react-router-dom";
import FormatMoney from "go-core/components/Formatters/FormatMoney";
import { PaymentStatus } from "../../../../../../../../services/Api/Public/types";
import StickyFooter from "../../../../components/StickyFooter";
import { OrderContext } from "../../../../contexts/OrderContext";
import OrderFooterPaymentMethods from "./OrderFooterPaymentMethods";

const OrderFooterPayment = () => {
	const { t } = useTranslation();
	const history = useHistory();
	const match = useRouteMatch();
	const { order } = useContext(OrderContext);

	if (!order) return <></>;

	if (
		order.payment_status !== PaymentStatus.OPEN ||
		order.payment_status.length === 0 ||
		!order.online_payment_enabled
	)
		return <></>;

	const handleOnClick = () => {
		history.push(`${match.url}/${order.tip_available ? "tip" : "payment"}`);
	};

	return (
		<StickyFooter dataTestId="e-order-footer-payment">
			<Button onClick={handleOnClick}>{`${t("modules.e_order.action.pay.title")}: ${FormatMoney(
				order.to_pay
			)}`}</Button>
			<OrderFooterPaymentMethods paymentMethods={order.payment_methods} />
		</StickyFooter>
	);
};

export default OrderFooterPayment;
